
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import {
  exportTransaction,
  getFund,
  getTransaction,
  setBanance,
  editAttach
} from '@/api/merchant/fund'
import pagination from '@/components/Pagination/index.vue'
import exchangeRate from './exchangeRate.vue'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import { AppModule } from '@/store/modules/app'
import { merchantBananceRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { operationMessage } from '@/utils/message'
import { checkNeedAudit } from '@/utils/permission'
import { delObjEmptyKey } from '@/utils'
import PicsUploader from '@/components/PicsUploader/index.vue'
import { getFileUploadURL } from '@/utils/constant'
import { getType } from '@/utils/cookies'

@Component({
  name: 'fund',
  components: {
    pagination,
    exchangeRate,
    PicsUploader
  }
})
export default class extends mixins(productOptionMixin, currencyOptionMixin) {
  @Prop({ required: true }) merchant_no!: string
  get language() {
    return AppModule.language
  }
  private tabName: string = 'Accounts Balance'
  private loading: boolean = false
  private balanceList: any[] = []
  private transactionList: any[] = []
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  queryForm: any = {
    order_number: '',
    start_time: null,
    end_time: null,
    min_amount: '',
    max_amount: '',
    cause: null,
    id: '',
    test_order: null,
    balance_type: 'balance'
  }
  private causeList: any[] = []
  private pickerOptions = pickerOptions
  private date: any[] = getCurrentDate()
  private listLoading: Boolean = false
  private listLoading2: Boolean = false
  private openRateDialog = false
  private dialogVisible = false
  private attachVisible = false
  private setForm: any = {
    currency: '',
    operation_type: 'change_balance',
    amount: '',
    in_or_out: '',
    remarks: '',
    google_code: '',
    description: '',
    attach: []
  }
  private attachForm: any = {
    attach: []
  }
  private rules = merchantBananceRules

  private apiUrl: string = getFileUploadURL() + '/upload-file'
  private fileList: any[] = []
  private imgVisible: boolean = false
  private dialogImageUrl = ''

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading2 = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getTransaction(data).then((res: any) => {
        this.total = res.count
        this.transactionList = res.results
        this.listLoading2 = false
      })
    } catch (e) {
      this.listLoading2 = false
    }
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  // 编辑 attach 弹窗
  private attachId: any = ''
  private attachUrl: any = []
  private attachEdit(row: any) {
    this.attachVisible = true
    this.attachId = row.id
    this.attachUrl = row.attach
  }

  // 编辑 attach
  private async editAttach() {
    try {
      this.loading = true
      this.flag = true
      let data: any = {
        id: this.attachId,
        attach: this.setForm.attach
      }
      await editAttach(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message.success('Edit success')
        }
        if (this.language === 'zh_cn') {
          this.$message.success('编辑成功')
        }
        if (this.language === 'zh_tw') {
          this.$message.success('編輯成功')
        }
        // this.getTransaction(true)
        this.hadleGetFilesListApi()
        this.loading = false
        this.flagStr()
        this.attachVisible = false
      })
    } catch (e) {
      this.loading = false
      this.flagStr()
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      order_number: '',
      start_time: null,
      end_time: null,
      min_amount: '',
      max_amount: '',
      cause: null,
      id: '',
      test_order: null,
      balance_type: 'balance'
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    // this.getTransaction(true)
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.pickerChange()
    })
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.date = getCurrentDate()
  }

  private async getFund() {
    this.listLoading = true
    try {
      await getFund(this.merchant_no).then((res: any) => {
        this.balanceList = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async setBanance() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const data: any = {
          merchant_no: this.merchant_no,
          ...this.setForm
        }
        try {
          this.loading = true
          await setBanance(data).then((res: any) => {
            operationMessage(
              checkNeedAudit('change_merchant_balance') !== undefined
            )
            this.loading = false
            this.dialogVisible = false
          })
        } catch (e) {
          this.loading = false
        }
      }
    })
  }

  private async exportData() {
    try {
      this.listLoading = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await exportTransaction(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private async getTransaction(isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    this.listLoading2 = true
    const data: any = {
      merchant_no: this.merchant_no,
      page: this.listQuery.page,
      ...this.queryForm
    }
    try {
      await getTransaction(data).then((res: any) => {
        this.total = res.count
        this.transactionList = res.results
        this.listLoading2 = false
      })
    } catch (e) {
      this.listLoading2 = false
    }
  }

  private closeDialog() {
    this.init()
    this.setForm = {
      currency: '',
      operation_type: 'change_balance',
      amount: '',
      in_or_out: '',
      remarks: '',
      attach: []
    }
  }

  private openDialog(obj: any) {
    this.setForm.currency = obj.currency
    this.dialogVisible = true
  }

  private async init() {
    await this.getFund()
    // await this.getTransaction(true)
    await this.hadleGetFilesListApi()
    await AppModule.GetCauseList().then((res: any) => {
      this.causeList = res
    })
  }

  private sysType: any = ''
  mounted() {
    this.sysType = getType()
    this.init()
  }
}
